(function(){
  var bus = {};
  function on(name, cb){
    (bus[name] = bus[name] || []).push(cb);
    return function(){ bus[name] = (bus[name]||[]).filter(function(x){ return x !== cb; }); };
  }
  function emit(name, payload){
    var list = bus[name] || [];
    for (var i = 0; i < list.length; i++) { try { list[i](payload); } catch(e){} }
  }
  function debounce(fn, ms){
    var t; return function(){
      var ctx = this, args = arguments;
      clearTimeout(t); t = setTimeout(function(){ fn.apply(ctx, args); }, ms);
    };
  }
  window.__themeEvents = window.__themeEvents || { on: on, emit: emit, debounce: debounce };
})();
